// extracted by mini-css-extract-plugin
export var primitiveLabel = "_sw-0";